import { NgModule } from '@angular/core';
import { ReportSummaryItemComponent } from '../components/report-summary-item/report-summary-item';
import { IonicModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';
import { SupplierSelectorComponentModule } from './supplier-selector/supplier-selector.module';
import { PurchaseNumberDirective } from '../directives/po-number.directive';

@NgModule({
  declarations: [
    ReportSummaryItemComponent,
    PurchaseNumberDirective,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
  ],
  exports: [
    ReportSummaryItemComponent,
    SupplierSelectorComponentModule,
    PurchaseNumberDirective,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/modules/shared.module.ts